export const AUTO_CLEAN = 'AUTO_CLEAN';
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';
export const RESET_DEVICE = 'RESET_DEVICE';
export const FIND_MY_DEVICE = 'FIND_MY_DEVICE';
export const UPDATE_FIRMWARE = 'UPDATE_FIRMWARE';
export const SYNCHRONIZE = 'SYNCHRONIZE';
export const CONNECT = 'CONNECT';
export const DATA_COLLECTION = 'DATA_COLLECTION';
